import React, { useState } from 'react';
import axios from 'axios';
import './ContactUs.css';

function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      await axios.post(`${process.env.REACT_APP_API_URL}/api/tickets`, { name, email, message });
      setSubmitted(true);
    } catch (err) {
      console.error('Error submitting ticket:', err);
      setError('Failed to submit ticket. Please try again.');
    }
  };

  return (
    <div className="contact-page page-shell">
      <div className="contact-layout">
        <div className="contact-intro">
          <span className="tag">Support</span>
          <h1 className="page-title">Talk to the Vix team</h1>
          <p className="page-lead">
            Logged-in customers will get access to real-time chat. If you do not have an account,
            send a ticket and we will respond by email within 24-48 hours.
          </p>
          <div className="contact-info section-card">
            <h3>Support hours</h3>
            <p className="muted-text">Monday to Friday, 8:00 to 18:00 (GMT+2)</p>
            <h3>Support email</h3>
            <p className="muted-text">support@vixalgotrading.com</p>
          </div>
        </div>

        <div className="contact-form section-card">
          {submitted ? (
            <div className="contact-success">
              <h2>Ticket received</h2>
              <p className="muted-text">We will get back to you shortly. Keep an eye on your inbox.</p>
            </div>
          ) : (
            <>
              <h2>Send a support ticket</h2>
              {error ? <p className="contact-error">{error}</p> : null}
              <form onSubmit={handleSubmit} className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows="5"
                    required
                  />
                </div>
                <button type="submit">Submit Ticket</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
